import { IntakeQuestion } from '../types/conversation';

export const intakeQuestions: IntakeQuestion[] = [
  {
    id: 'focusAreas',
    type: 'multi',
    prompt: 'Which wellness areas should we pay special attention to right now?',
    helper: 'Pick all that resonate. We blend formulas around your top priorities.',
    options: [
      { value: 'libido', label: 'Libido & intimacy' },
      { value: 'sleep', label: 'Sleep quality' },
      { value: 'stress', label: 'Stress resilience' },
      { value: 'energy', label: 'Daytime energy' },
      { value: 'digestion', label: 'Digestion & gut' },
      { value: 'cycle', label: 'Cycle harmony' },
      { value: 'mood', label: 'Mood & emotional balance' },
      { value: 'immunity', label: 'Immune support' }
    ]
  },
  {
    id: 'chiefConcern',
    type: 'text',
    prompt: 'Give Soupcon a little context. What feels most off in your body or routine?',
    helper: 'Share details like when it started, triggers you notice, and goals for the next month.',
    placeholder: 'Example: "Libido has dipped over the last six months, especially when I feel cold or wiped out."'
  },
  {
    id: 'energyLevel',
    type: 'choice',
    prompt: 'How does your energy feel most days?',
    options: [
      { value: 'very-low', label: 'Running on empty by noon' },
      { value: 'low', label: 'Dips in the afternoon but manageable' },
      { value: 'steady', label: 'Steady barring an intense day' },
      { value: 'reserve', label: 'Plenty in reserve, just fine-tuning' }
    ]
  },
  {
    id: 'temperature',
    type: 'choice',
    prompt: 'Do you generally run cool, neutral, or warm?',
    helper: 'This helps us see whether yang or yin support should lead.',
    options: [
      { value: 'runsCold', label: 'I reach for blankets. Hands/feet get chilly.' },
      { value: 'balanced', label: 'Fairly balanced or seasonal.' },
      { value: 'runsWarm', label: 'I prefer cool rooms and wake feeling flushed.' }
    ]
  },
  {
    id: 'sleepQuality',
    type: 'choice',
    prompt: 'Tell us about sleep over the last two weeks.',
    options: [
      { value: 'restless', label: 'Hard to fall asleep or mind races.' },
      { value: 'middle-of-night', label: 'I wake between 1-3am and struggle to settle.' },
      { value: 'unrefreshed', label: 'I sleep but wake groggy or heavy.' },
      { value: 'solid', label: 'Mostly solid. Just fine-tuning other areas.' }
    ]
  },
  {
    id: 'digestive',
    type: 'choice',
    prompt: 'What best describes digestion lately?',
    options: [
      { value: 'smooth', label: 'Steady and regular.' },
      { value: 'bloating', label: 'Bloating or rib-side tightness after meals.' },
      { value: 'loose', label: 'Tending toward loose stools.' },
      { value: 'alternating', label: 'Swing between loose and dry.' }
    ]
  },
  {
    id: 'tongue',
    type: 'choice',
    prompt: 'Tongue check-in (colour/coat) if you are comfortable sharing.',
    helper: 'Use a quick mirror selfie under natural light. Skip if unsure.',
    options: [
      { value: 'pale', label: 'Pale or swollen with teeth marks.' },
      { value: 'red-thin', label: 'Red tip with thin coating.' },
      { value: 'scarlet', label: 'Scarlet and dry with little coat.' },
      { value: 'purple', label: 'Purple or dusky with spots.' },
      { value: 'greasy', label: 'Yellow/greasy coating.' },
      { value: 'skip', label: 'Prefer not to share.' }
    ]
  },
  {
    id: 'cycle',
    type: 'choice',
    prompt: 'Menstrual or hormonal cycle notes (skip if not relevant).',
    options: [
      { value: 'pms-irritability', label: 'PMS mood swings or irritability.' },
      { value: 'painful', label: 'Cramps or clotting we should flag.' },
      { value: 'irregular', label: 'Cycles are irregular or absent.' },
      { value: 'post-menopause', label: 'Post-menopause or not cycling.' },
      { value: 'not-applicable', label: 'Not applicable.' }
    ]
  },
  {
    id: 'safetyFlags',
    type: 'multi',
    prompt: 'Any safety considerations we should know before shipping?',
    helper: 'Always escalated to a licensed TCM practitioner for final review.',
    options: [
      { value: 'pregnant', label: 'Pregnancy or actively trying' },
      { value: 'fertilityTreatments', label: 'Working with fertility treatments' },
      { value: 'bloodPressure', label: 'Blood pressure medications' },
      { value: 'autoimmune', label: 'Autoimmune conditions' },
      { value: 'none', label: 'None apply' }
    ]
  }
];
